import React from 'react';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 100% { 
    transform: scale(0.0);
  } 50% { 
    transform: scale(1.0);
  }
`;

const BounceLoader = styled.div`
  width: 80px;
  height: 80px;
  position: relative;
  margin: 4.85rem auto;

  @media only screen and (max-width: 550px) {
    margin: 3.6rem auto;
  }

  > div {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    opacity: 0.6;
    position: absolute;
    background-color: #E80E29;
    top: 0;
    left: 0;
    animation: ${bounce} 1.5s infinite ease-in-out;

    :last-of-type {
      animation-delay: -.75s;
    }
  }
`;

const PageLoader = () => (
  <BounceLoader>
    <div />
    <div />
  </BounceLoader>
);

export default PageLoader;
